import React from "react";
import styled from "@emotion/styled";

function DateGrid({ schedule, startOfMonthOffset }) {
  return (
    <Container>
      <DaysOfTheWeekHeader />
      {getArrayOfLengthN(startOfMonthOffset).map(() => (
        <Spacer />
      ))}
      {schedule.map((dayActivities, i) => (
        <DayGridItem date={i + 1} activities={dayActivities} />
      ))}
    </Container>
  );
}

export default DateGrid;

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  @media (max-width: 800px) {
    flex-direction: column;
  }
`;

function DaysOfTheWeekHeader() {
  const daysOfTheWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  return daysOfTheWeek.map(day => <DayOfWeekGridItem>{day}</DayOfWeekGridItem>);
}

const AbstractGridBase = styled.div`
  width: ${getGridItemWidthInVW()}vw;
  @media (max-width: 800px) {
    width: calc(100% - 2em);
    margin: auto;
  }
  box-sizing: border-box;
  padding: 0em 1em;
`;

const DayOfWeekGridItem = styled(AbstractGridBase)`
  height: 30px;
  text-align: right;
  border-bottom: 1px solid lightgrey;
  @media (max-width: 800px) {
    display: none;
  }
`;

function DayGridItem({ date, activities = [] }) {
  if (isMobile() && activities.length === 0) return null;
  return (
    <DayGridContainer date={date}>
      <ul>
        {activities.map(activity => (
          <Activity country={activity.country}>{activity.description}</Activity>
        ))}
      </ul>
    </DayGridContainer>
  );
}

const DayGridContainer = styled(AbstractGridBase)`
  border-right: 1px solid lightgrey;
  border-bottom: 1px solid lightgrey;
  position: relative;
  @media (max-width: 800px) {
    border: 1px solid #eee;
    border-radius: 8px;
    margin-bottom: 1em;
  }
  ul {
    padding: 1.5em 1em 1em 1em;
    font-size: 11px;
    @media (max-width: 800px) {
      font-size: 18px;
    }
  }
  &::after {
    content: "${({ date }) => date}";
    position: absolute;
    top: 0.5em;
    right: 0.5em;
    z-index: 1;
    color: grey;
    @media (max-width: 800px) {
      font-size: 20px;
    }
  }
`;

const Activity = styled.li`
  color: ${({ country }) => getCountryColor(country)};
  margin-bottom: 0.5em;
`;

const Spacer = styled(DayGridContainer)`
  background-color: rgba(0, 0, 0, 0.05);
  @media (max-width: 800px) {
    display: none;
  }
`;

function getCountryColor(countryName) {
  switch (countryName) {
    case "thailand":
      return "#f44336";
    case "bali":
      return "#1976d2";
    case "laos":
      return "#512da8";
    case "vietnam":
      return "#4caf50";
    case "america":
      return "#212121";
  }
}

function getGridItemWidthInVW() {
  return (1 / 7) * 100;
}

function getArrayOfLengthN(n) {
  const arr = [];
  for (let i = 1; i < n + 1; i += 1) {
    arr.push(i);
  }
  return arr;
}

function isMobile() {
  return window.innerWidth < 800;
}
